<template>
  <div class="person">
    <div class="left">
      <el-image class="img" v-if="showData.head_picture" :src="showData.head_picture"></el-image>
      <div class="describe">
        <div class="nameAndRate">
          <div class="name">{{ showData.name }}</div>
          <!-- <div class="rate">
            <span>{{ showData.score }}</span>
            <el-rate
              class="ra"
              v-model="showData.score"
              :colors="[theme, theme, theme]"
              disabled
            ></el-rate>
          </div> -->
        </div>
        <div class="detail">
          <div class="a">
            <span :style="{ color: theme }">{{ showData.orders }}</span
            ><span>Orders</span>
          </div>
          <div class="b">
            <span :style="{ color: theme }">{{ showData.pay_rate }}%</span>
            <span v-if="role == 'writer'">
              Accepted
            </span>
            <span v-else>Pay Rate</span>
          </div>
          <div class="c">
            <span :style="{ color: theme }">{{ showData.reviews }}</span >
            <span v-if="role == 'writer'">Pay rate</span>
            <span v-else>Reviews</span>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <el-button class="btn" @click="chat" :style="{ color: theme, borderColor: theme }"
        >Chat</el-button
      >
    </div>
  </div>
</template>

<script>
import { normalTheme } from '@/styles/normal.scss';
import { writerTheme } from '@/styles/writer.scss';
export default {
  props: ['showData', 'orderDetail'],
  name: 'person',
  data: function () {
    return {};
  },
  computed: {
    role() {
      let role = localStorage.getItem('userInfo')
        ? JSON.parse(localStorage.getItem('userInfo')).role
        : '';
      return role;
    },
    normalTheme() {
      return normalTheme;
    },
    writerTheme() {
      return writerTheme;
    },
    theme() {
      return this.role === 'normal' ? this.normalTheme : this.writerTheme;
    },
  },
  methods: {
    chat() {
      this.$router.push({
        name: 'chat',
        query: {
          id: this.showData.id,
          order_no: this.orderDetail.order_number,
          orderId: this.orderDetail.id,
        },
        // params: { content: window.location.href },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.person {
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  .left {
    display: flex;
    align-items: center;
    .img {
      width: 70px;
      height: 70px;
      border-radius: 50%;
    }
    .describe {
      margin-left: 20px;
      .nameAndRate {
        display: flex;
        align-items: center;
        .name {
          font-size: 24px;
          font-family: Roboto-Bold, Roboto;
          font-weight: bold;
          color: #000000;
        }
        .rate {
          span {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
          }
          margin-left: 15px;
          display: flex;
          align-items: center;
          .ra {
            margin-left: 5px;
          }
        }
      }
      .detail {
        margin-top: 10px;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        .a,
        .b,
        .c {
          display: flex;
          align-items: center;
          span:first-child {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #577cf2;
          }
          span:last-child {
            margin-left: 5px;
          }
        }
        .b,
        .c {
          margin-left: 20px;
        }
      }
    }
  }
  .right {
    .btn {
      width: 137px;
      height: 42px;
      background: #ffffff;
      border-radius: 10px;
      border: 2px solid #577cf2;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #577cf2;
    }
  }
}
</style>
